import CommentThreadView from '@ckeditor/ckeditor5-comments/src/comments/ui/view/commentthreadview';
import { CkeditorConstants } from "../../src/utils/ckeditorconstants";

export default class CustomCommentThreadView extends CommentThreadView {
    constructor(...args) {
        super(...args);
    }

    getTemplate() {
        const templateDefinition = super.getTemplate();
        templateDefinition.children[0].children._items[1].template.children[1].template.children[0].children[0].label = "Post";
        templateDefinition.children[0].children._items[1].commentInputView.submitButtonView.withText = true;
        templateDefinition.children[0].children._items[1].commentInputView.cancelButtonView.withText = true;
        templateDefinition.children[0].children._items[1].commentInputView.submitButtonView.label = CkeditorConstants.commentLabels.POST;
        templateDefinition.children[0].children._items[1].commentInputView.submitButtonView.tooltip = CkeditorConstants.commentLabels.POST_COMMENT;
        templateDefinition.children[0].children._items[1].commentInputView.cancelButtonView.label = CkeditorConstants.commentLabels.CANCEL;
        templateDefinition.children[0].children._items[1].commentInputView.cancelButtonView.tooltip = CkeditorConstants.commentLabels.CANCEL_COMMENT;
        return templateDefinition;
    }
}